import React from 'react';
import { motion } from 'framer-motion';
import aboutImage from '../images/majestic.jpg';
import { Link } from 'react-router-dom';
import '../css/section.css';

const Section = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const slideInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (
    <section className="py-5 aboutsection white-text-section" id="about" aria-labelledby="about-heading">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="text-center mb-5"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 id="about-heading" className="display-7 fw-bold mb-3">
           Majestic  HOTEL  IN LUCKNOW
          </h2>

        </motion.div>

        {/* Content Row */}
        <div className="row g-4 align-items-center">
          {/* Image */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInLeft}
            viewport={{ once: true, amount: 0.2 }}
          >
            <img
              src={aboutImage}
              alt="Interior design showcase"
              className="img-fluid rounded shadow"
            />
          </motion.div>

          {/* Text Content */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInRight}
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="h4 fw-semibold mb-3">ABOUT Hotel Majestic</h3>
            <p className="mb-4">
             Hotel Majestic is a luxurious haven of elegance and comfort 🌟🏨, nestled in the heart of the city 🌆. Renowned for its world-class service and opulent ambiance 🛋️✨, this five-star destination offers guests an unforgettable stay. The rooms and suites are exquisitely designed, blending modern sophistication with timeless charm 🛌🖼️. Guests can indulge in culinary delights 🍽️ from around the world at the hotel’s award-winning restaurants, or unwind with a refreshing cocktail at the rooftop bar 🍸🌇, boasting panoramic city views.
            </p>

            <h3 className="h4 fw-semibold mb-3">Why Choose US</h3>
            <p className="mb-4">
             At Hotel Majestic i we understand the importance of every detail. From the grandeur of our hall to the personalized service we provide, our goal is to make your event extraordinary and memorable. Trust us to handle your special occasion with the utmost care and expertise.
            </p>

            <Link
              to="/About"
              className="custom-btn custom-btn-outline-white"
              aria-label="Learn more about our interior design products and services"
            >
              Learn More
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Section;